export default __webpack_public_path__ + "static/media/1.0a5732c1.jpg";